import { PASSWORD_RULE_MESSAGE } from '@gozoki/api-types/src/validation/messages'
import { PASSWORD_REGEX } from '@gozoki/tools'
import { z } from 'zod'

/** Fiche d'un compte BO : identité et mot de passe. Ses droits viennent de ses rôles v2. */
export const zUserAdminForm = z.object({
  email: z.email({ message: 'Email invalide.' }).max(50, { message: 'Email trop long.' }),

  firstName: z
    .string()
    .min(2, { message: 'Le prénom doit contenir au moins 2 caractères' })
    .max(30, { message: 'Le prénom doit contenir au maximum 30 caractères' }),

  lastName: z
    .string()
    .min(1, { message: 'Le nom de famille doit contenir au moins 1 caractère' })
    .max(30, { message: 'Le nom de famille doit contenir au maximum 30 caractères' }),

  password: z.string().regex(PASSWORD_REGEX, { message: PASSWORD_RULE_MESSAGE }).nullable(),
})
